// extracted by mini-css-extract-plugin
export default {"settings__element":"MatrixSettings_settings__element__cI8-v","settings":"MatrixSettings_settings__GpnGO"};